import * as React from 'react';

import { useBusiness } from 'hooks/business/useBusiness';
import { useCancellation } from 'hooks/cancellation/useCancellation';
import { useTeamPage } from 'hooks/page/team/useTeamPage';
import { usePreferences } from 'hooks/preferences/usePreferences';
import { getAverageRating } from 'hooks/review/helpers';
import { useReviews } from 'hooks/review/useReviews';
import { useWebsite } from 'hooks/website/useWebsite';

export const useAboutPage = () => {
  const { isMultiUser } = useBusiness();
  const { professionals, handleBook } = useTeamPage();
  const { reviews, showReviews } = useReviews();
  const { showTeam } = useWebsite();

  const { areGiftCardsEnabled, isFixedLocation, doesHouseCalls } =
    usePreferences();
  const { hasCancellationPolicy, cancellationPolicyText } = useCancellation();

  const {
    about: { aboutText },
  } = useWebsite();

  const avgRating = React.useMemo(() => {
    return getAverageRating(reviews);
  }, [reviews]);

  return {
    aboutText,
    areGiftCardsEnabled,
    showReviews,
    hasCancellationPolicy,
    cancellationPolicyText,
    avgRating,
    isFixedLocation,
    doesHouseCalls,
    showTeam: showTeam && isMultiUser,
    professionals: professionals.slice(0, 3),
    handleBook,
    reviews,
  };
};
